import { useCallback } from 'react';

import { useProfileManager } from '@/shared/hooks/useProfileManager';

import { TelemetryContentPlace, TelemetryContentType } from '../../Player';
import { getPromoPlayerConfig } from '../utils/get-promo-player-config';
import { StreamHandler } from '../../feature-player/hooks/config/use-stream-handler';

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
    telemetryContentType: TelemetryContentType;
}

export const usePromoPlayerConfigHandler: (props: Props) => StreamHandler = (props) => {
    const profileManager = useProfileManager();

    return useCallback(
        (baseInfo) => {
            if (baseInfo?.__typename === 'OttTrailer') {
                return getPromoPlayerConfig(baseInfo, props, { profileManager });
            }
            return null;
        },
        [profileManager, props]
    );
};
